<template>
  <div @click="getProdByCategory(item)">
    <span>{{ item }}</span>
  </div>
</template>

<script>
export default {
  name: 'Category',
  props: ['item'],
  methods: {
    getProdByCategory (item) {
      console.log(item, '<<<< item di category')
      this.$store.dispatch('getProdByCategory', item)
    }
  }
}
</script>

<style>

</style>
